import { dispatchSnackbarNegativeEvent, RouteLeavingGuard } from '@dreryk/react-components';
import { useDraftCreateCqrsCommand } from '@dreryk/react-draft';

import { visitTranslationKeys } from '../../../translations';
import { getDocumentTemplateDraftTag, getVisitDraftTag } from '../../../visit/visit.draft';
import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { ReferralToDiagnosticExaminationFormController } from './ReferralToDiagnosticExaminationForm/ReferralToDiagnosticExaminationForm.types';

type ReferralToDiagnosticExaminationRouteLeavingGuardProps = Pick<
   ReferralToDiagnosticExaminationFormController,
   'formState' | 'handleSubmitDraft'
> & {
   readonly visitId: number;
   readonly electronic: boolean;
};

export const ReferralToDiagnosticExaminationRouteLeavingGuard = (
   props: ReferralToDiagnosticExaminationRouteLeavingGuardProps
): JSX.Element => {
   const { executeAsync: saveReferralToDiagnosticExaminationDraft } = useDraftCreateCqrsCommand({
      onUnexpectedError: () => {
         dispatchSnackbarNegativeEvent(visitTranslationKeys.draftSaveFail);
      },
   });
   return (
      <RouteLeavingGuard
         active={props.formState.isDirty}
         onLeave={props.handleSubmitDraft(async (values) =>
            saveReferralToDiagnosticExaminationDraft({
               token: getReferralDraftToken(
                  props.electronic ? 'electronicReferralToDiagnosticExamination' : 'referralToDiagnosticExamination',
                  props.visitId
               ),
               tags: props.electronic
                  ? undefined
                  : [getVisitDraftTag(props.visitId), getDocumentTemplateDraftTag(props.visitId)],
               contents: values,
            })
         )}
         successMessage={referralTranslationKeys.referralDraftSaved}
         testId={'diagnosticExamination'}
      />
   );
};
